export interface FlowStep {
    label: string
    system: string
    time: string
}

export const managedFlowSteps: Array<FlowStep> = [
    { label: "Booking received from carrier", system: "Meridian", time: "0.4s" },
    { label: "Mapped to the purchase order", system: "ERP", time: "0.9s" },
    { label: "Customs entry filed with broker", system: "Broker", time: "2.1s" },
    { label: "Gate slot booked at the terminal", system: "RTM", time: "1.3s" },
    { label: "Warehouse told the new ETA", system: "WMS", time: "0.6s" },
    { label: "Proof of delivery matched to invoice", system: "Finance", time: "0.8s" }
]

export const pilotMiniChat = {
    question: "Any containers stuck at Felixstowe?",
    answer: "Two. MSKU 418220 is on a customs hold and TGHU 902117 is waiting on a gate slot. I've rebooked the slot for 14:30."
}

export const apiScopes: Array<string> = ['read-only', 'run-flows', 'full access']

export interface FlowRunStep {
    id: string
    label: string
    text: string
}

export const flowRunSteps: Array<FlowRunStep> = [
    { id: 'trigger', label: "Trigger", text: "A booking, EDI message, email or API call starts the flow." },
    { id: 'normalise', label: "Normalise", text: "Every source is mapped into one clean shipment model." },
    { id: 'check', label: "Check", text: "Rules catch missing documents, holds and mismatches early." },
    { id: 'deliver', label: "Deliver", text: "Updates land in your ERP, warehouse system and customer portal." },
    { id: 'watch', label: "Watch", text: "Our ops desk monitors every run and handles the exceptions." }
]
